/* ==========================================================================
   Love Brands — capa de movimiento (v2).

   LA REGLA QUE NO SE ROMPE
   Nada se oculta desde el CSS base. El elemento nace VISIBLE y la animacion
   corre DESDE su estado invisible hacia el normal (`animation-fill-mode: both`
   aplicado al anadir una clase). Si el JS no corre, si el observer falla o si
   el navegador es viejo, el contenido se ve igual — solo sin entrada. El peor
   caso es "sin animacion", nunca "sin contenido". Ya paso una vez: ampliar el
   `anime.set(opacity:0)` de `animations.js` dejo las resenas en blanco.

   QUE HACE, DE MAS A MENOS NOTORIO
   1. Titulares palabra por palabra (donde mas se siente el cambio de ritmo).
   2. Imagenes que se abren con una cortina (clip-path), no un fundido.
   3. Los numeros que son DATOS no cuentan: entran, pero nunca cambian.
   4. Los checks de la comparativa entran con rebote, en cascada.
   5. Parallax suave en las bandas de imagen.
   6. Tarjetas en cascada con escala.
   ========================================================================== */
(function () {
  if (!window.matchMedia || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var IO_OPTS = { threshold: 0.08, rootMargin: '0px 0px -6% 0px' };

  /* Un elemento ya animado por `animations.js` no se toca: dos sistemas
     peleando por opacity es justo lo que deja cosas escondidas. */
  function free(el) {
    if (!el || el.closest('[data-reveal]')) return false;
    var o = parseFloat(getComputedStyle(el).opacity);
    return !(o < 0.9);
  }

  function observe(el, fn) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        fn(e.target);
      });
    }, IO_OPTS);
    io.observe(el);
  }

  /* ---------------------------------------------------------------
     1) TITULARES PALABRA POR PALABRA
     Solo se parten titulares de texto plano. Si el titular trae etiquetas
     dentro (la cabecera de la comparativa, por ejemplo) se deja quieto:
     reescribir su HTML romperia el maquetado.
  --------------------------------------------------------------- */
  var HEADS = '.lp__h2, .pdp-love__head, .pdp-reviews__title, .comm-title, .ffh-how h2, .page-hero__title';

  function splitWords(el) {
    if (el.__lbSplit) return false;
    if (el.children.length) return false;              // tiene etiquetas dentro
    var txt = (el.textContent || '').trim();
    if (!txt || txt.length > 90) return false;
    var words = txt.split(/\s+/);
    if (words.length < 2) return false;
    el.__lbSplit = true;
    el.setAttribute('aria-label', txt);
    el.innerHTML = words.map(function (w) {
      return '<span class="lb-w" aria-hidden="true"><span class="lb-w__i">' + w + '</span></span>';
    }).join(' ');
    return true;
  }

  [].forEach.call(document.querySelectorAll(HEADS), function (h) {
    if (!free(h)) return;
    if (!splitWords(h)) return;
    observe(h, function (t) {
      [].forEach.call(t.querySelectorAll('.lb-w__i'), function (w, i) {
        w.style.animationDelay = (i * 65) + 'ms';
        w.classList.add('lb-in-w');
      });
    });
  });

  /* ---------------------------------------------------------------
     2) IMAGENES QUE SE ABREN
     Cortina + escala. Se aplica al contenedor para que el recorte
     redondeado no se mueva.
  --------------------------------------------------------------- */
  var WIPES = '.pdp-life__img, .ffh-hero-img, .lp-story__media, .pdp-gal__main, .shop-life';
  [].forEach.call(document.querySelectorAll(WIPES), function (el) {
    if (!free(el)) return;
    observe(el, function (t) { t.classList.add('lb-wipe'); });
  });

  /* ---------------------------------------------------------------
     3) LOS NUMEROS QUE SON DATOS NO SE ANIMAN

     La nota y el numero de resenas son AFIRMACIONES, no adorno. Contarlos
     desde cero significa que durante ~1,1 s el movil ensena «0.0 ★ 0 Reviews»
     justo donde el comprador decide — dice lo contrario de la verdad. Y si el
     navegador dejaba de dar frames (pestana de fondo, hilo atascado) el numero
     se quedaba congelado en una cifra falsa: «0.4» donde pone 4.9.

     Ningun seguro arregla eso del todo, porque el problema no es el final de la
     animacion sino su principio. Asi que la cifra se pinta REAL desde el primer
     fotograma y no se toca nunca; lo que entra es el envoltorio. Adorno, no dato.
  --------------------------------------------------------------- */
  var NUMS = '.pdp-reviews__score, .pdp-reviews__count, .ffh-count, .ffh-score, .lp-proof__score, [data-lb-count]';

  [].forEach.call(document.querySelectorAll(NUMS), function (el) {
    if (!free(el)) return;
    observe(el, function (t) { t.classList.add('lb-num'); });
  });

  /* ---------------------------------------------------------------
     4) COMPARATIVA: los checks entran con rebote
  --------------------------------------------------------------- */
  [].forEach.call(document.querySelectorAll('.pdp-compare__table'), function (tbl) {
    observe(tbl, function (t) {
      [].forEach.call(t.querySelectorAll('.pdp-compare__mark'), function (m, i) {
        m.style.animationDelay = (i * 55) + 'ms';
        m.classList.add('lb-pop');
      });
    });
  });

  /* ---------------------------------------------------------------
     5) PARALLAX en bandas de imagen (ligado al scroll, con rAF)
  --------------------------------------------------------------- */
  var paraTargets = [].filter.call(
    document.querySelectorAll('.pdp-life__img img, .shop-life img, .lp-story__media img'),
    function (el) { return el.offsetParent !== null; }
  );

  if (paraTargets.length) {
    var ticking = false;
    function para() {
      var vh = window.innerHeight || 800;
      paraTargets.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var mid = r.top + r.height / 2;
        var off = ((mid - vh / 2) / vh) * -26;          // +-13px aprox
        img.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0) scale(1.06)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(para);
    }, { passive: true });
    para();
  }

  /* ---------------------------------------------------------------
     6) REJILLAS EN CASCADA
  --------------------------------------------------------------- */
  var GROUPS = [
    ['.pdp-reviews__grid', '.pdp-rev'],
    ['.pdp-love__grid', '.pdp-love__pt'],
    ['.pdp-dist', '.pdp-dist__row'],
    ['.lp-trust__grid', '.lp-trust__item'],
    ['.lp-steps__grid', '.lp-step'],
    ['.lp-faq__list', 'details'],
    ['.ffh-feat', 'li'],
    ['.ffh-reviews', '.ffh-rv']
  ];

  GROUPS.forEach(function (g) {
    [].forEach.call(document.querySelectorAll(g[0]), function (c) {
      var kids = [].filter.call(c.querySelectorAll(':scope > ' + g[1]), free);
      if (!kids.length) return;
      observe(c, function () {
        kids.forEach(function (k, i) {
          k.style.animationDelay = (i * 85) + 'ms';
          k.classList.add('lb-in');
        });
      });
    });
  });

  /* Sueltos que no forman rejilla */
  var SINGLES = '.lp-trust, .lp-steps, .lp-faq, .pdp-compare__table, .pdp-reviews__summary, .ffh-how, .pdp-fresh';
  [].forEach.call(document.querySelectorAll(SINGLES), function (el) {
    if (!free(el)) return;
    observe(el, function (t) { t.classList.add('lb-in'); });
  });

  /* ---------------------------------------------------------------
     7) AURA: resplandor detras de las secciones grandes
     Solo donde no hay ya manchas de color propias, para no ensuciar.
  --------------------------------------------------------------- */
  var AURA = '.pdp-reviews, .lp-faq, .lp-steps, .lp-trust, .comm, .pdp-compare';
  [].forEach.call(document.querySelectorAll(AURA), function (s) {
    if (s.querySelector('[class*="blob"]')) return;
    s.classList.add('lb-aura');
  });

  /* ---------------------------------------------------------------
     8) TARJETAS QUE SE INCLINAN HACIA EL CURSOR
     Un solo listener por rejilla (no uno por tarjeta) y la rotacion se
     escribe en variables CSS, asi el navegador solo recompone.
  --------------------------------------------------------------- */
  var MAX = 7; // grados
  [].forEach.call(document.querySelectorAll('.pdp-reviews__grid, .ffh-reviews, .lp-trust__grid'), function (grid) {
    var cards = grid.querySelectorAll('.pdp-rev, .ffh-rv, .lp-trust__item');
    if (!cards.length) return;
    [].forEach.call(cards, function (c) { c.classList.add('lb-tilt'); });

    grid.addEventListener('pointermove', function (e) {
      var card = e.target.closest('.pdp-rev, .ffh-rv, .lp-trust__item');
      if (!card) return;
      var r = card.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width  - 0.5;
      var py = (e.clientY - r.top)  / r.height - 0.5;
      card.style.setProperty('--ry', (px *  MAX).toFixed(2) + 'deg');
      card.style.setProperty('--rx', (py * -MAX).toFixed(2) + 'deg');
    }, { passive: true });

    grid.addEventListener('pointerleave', function () {
      [].forEach.call(cards, function (c) {
        c.style.setProperty('--rx', '0deg');
        c.style.setProperty('--ry', '0deg');
      });
    }, { passive: true });
  });

  /* ---------------------------------------------------------------
     9) ENTRADA DEL HERO AL CARGAR
     No espera al scroll: es lo primero que se ve.
  --------------------------------------------------------------- */
  var heroBits = [
    '.ffh-pill', '.ffh-pill-tx', '.ffh-desc', '.ffh-top', '.ffh-top-tx',
    '.ffh-flash', '.ffh-now', '.ffh-box', '.ffh-cta',
    '.lp-video-pdp__title', '.lp-video-pdp__meta'
  ];
  var seq = [];
  heroBits.forEach(function (s) {
    var el = document.querySelector(s);
    if (el && free(el)) seq.push(el);
  });
  seq.forEach(function (el, i) {
    el.style.animation = 'lbHeroIn 1s cubic-bezier(.16,.84,.34,1) both';
    el.style.animationDelay = (90 + i * 75) + 'ms';
  });

  /* ---------------------------------------------------------------
     10) ESTRELLAS QUE ENTRAN GIRANDO
  --------------------------------------------------------------- */
  [].forEach.call(document.querySelectorAll('.pdp-rev__stars, .ffh-rv-st, .lp-proof__stars'), function (row) {
    var stars = row.querySelectorAll('svg');
    if (!stars.length) return;
    observe(row, function () {
      [].forEach.call(stars, function (s, i) {
        s.style.animationDelay = (i * 70) + 'ms';
        s.classList.add('lb-star');
      });
    });
  });
})();
